var Q = Object.defineProperty;
var _ = (e, t, n) => t in e ? Q(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var O = (e, t, n) => _(e, typeof t != "symbol" ? t + "" : t, n);
import { QueryClient as K, useMutation as l, useQuery as q, useInfiniteQuery as j, queryOptions as p, infiniteQueryOptions as F } from "@tanstack/react-query";
import { Client as D, PrivateKey as h, cryptoUtils as P, RCAPI as N } from "@hiveio/dhive";
import g from "hivesigner";
class M {
  constructor() {
    O(this, "length", 0);
  }
  clear() {
    throw new Error("Method not implemented.");
  }
  getItem(t) {
    return this[t];
  }
  key(t) {
    return Object.keys(this)[t];
  }
  removeItem(t) {
    delete this[t];
  }
  setItem(t, n) {
    this[t] = n;
  }
}
const i = {
  privateApiHost: "https://ecency.com",
  storage: typeof window > "u" ? new M() : window.localStorage,
  storagePrefix: "ecency",
  hiveClient: new D(
    [
      "https://api.hive.blog",
      "https://api.deathwing.me",
      "https://rpc.mahdiyari.info",
      "https://api.openhive.network",
      "https://techcoderx.com",
      "https://hive-api.arcange.eu",
      "https://api.syncad.com",
      "https://anyx.io",
      "https://api.c0ff33a.uk",
      "https://hiveapi.actifit.io",
      "https://hive-api.3speak.tv"
    ],
    {
      timeout: 2e3,
      failoverThreshold: 2,
      consoleOnFailover: !0
    }
  ),
  heliusApiKey: void 0,
  queryClient: new K(),
  plausibleHost: "https://pl.ecency.com"
};
var S;
((e) => {
  function t(n) {
    i.queryClient = n;
  }
  e.setQueryClient = t;
})(S || (S = {}));
function E(e) {
  let t = atob(e);
  if (t[0] === "{")
    return JSON.parse(t);
}
const d = (e) => {
  try {
    const t = i.storage.getItem(
      i.storagePrefix + "_user_" + e
    );
    return E(JSON.parse(t));
  } catch (t) {
    console.error(t);
    return;
  }
}, y = (e) => d(e) && d(e).accessToken, k = (e) => d(e) && d(e).postingKey, T = (e) => d(e) && d(e).loginType, L = (e) => d(e) && d(e).refreshToken;
function J() {
  return new Promise((e) => {
    var t;
    (t = window.hive_keychain) == null || t.requestHandshake(() => {
      e();
    });
  });
}
const w = (e, t, n, o = null) => new Promise((r, c) => {
  var a;
  (a = window.hive_keychain) == null || a.requestBroadcast(
    e,
    t,
    n,
    (s) => {
      s.success || c({ message: "Operation cancelled" }), r(s);
    },
    o
  );
}), R = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  broadcast: w,
  handshake: J
}, Symbol.toStringTag, { value: "Module" }));
function I(e = [], t, n) {
  return l({
    mutationKey: [...e, t],
    mutationFn: async (o) => {
      if (!t)
        throw new Error(
          "[Core][Broadcast] Attempted to call broadcast API with anon user"
        );
      const r = k(t);
      if (r) {
        const s = h.fromString(r);
        return i.hiveClient.broadcast.sendOperations(
          n(o),
          s
        );
      }
      const c = T(t);
      if (c && c == "keychain")
        return w(t, n(o), "Posting").then((s) => s.result);
      let a = y(t);
      if (a)
        return (await new g.Client({
          accessToken: a
        }).broadcast(n(o))).result;
      throw new Error(
        "[SDK][Broadcast] – cannot broadcast w/o posting key or token"
      );
    }
  });
}
async function B(e, t, n) {
  if (!e)
    throw new Error(
      "[Core][Broadcast] Attempted to call broadcast API with anon user"
    );
  const o = {
    id: t,
    required_auths: [],
    required_posting_auths: [e],
    json: JSON.stringify(n)
  }, r = k(e);
  if (r) {
    const s = h.fromString(r);
    return i.hiveClient.broadcast.json(
      o,
      s
    );
  }
  const c = T(e);
  if (c && c == "keychain")
    return w(e, [["custom_json", o]], "Posting").then((s) => s.result);
  let a = y(e);
  if (a)
    return (await new g.Client({
      accessToken: a
    }).customJson([], [e], t, JSON.stringify(n))).result;
  throw new Error(
    "[SDK][Broadcast] – cannot broadcast w/o posting key or token"
  );
}
function ee() {
  return new K({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        // staleTime: 60 * 1000,
        refetchOnWindowFocus: !1,
        refetchOnMount: !1
      }
    }
  });
}
const u = () => i.queryClient;
var C;
((e) => {
  function t(s) {
    return u().getQueryData(s);
  }
  e.getQueryData = t;
  function n(s) {
    return u().getQueryData(s);
  }
  e.getInfiniteQueryData = n;
  async function o(s) {
    return await u().prefetchQuery(s), t(s.queryKey);
  }
  e.prefetchQuery = o;
  async function r(s) {
    return await u().prefetchInfiniteQuery(s), n(s.queryKey);
  }
  e.prefetchInfiniteQuery = r;
  function c(s) {
    return {
      prefetch: () => o(s),
      getData: () => t(s.queryKey),
      useClientQuery: () => q(s),
      fetchAndGet: () => u().fetchQuery(s)
    };
  }
  e.generateClientServerQuery = c;
  function a(s) {
    return {
      prefetch: () => r(s),
      getData: () => n(s.queryKey),
      useClientQuery: () => j(s),
      fetchAndGet: () => u().fetchInfiniteQuery(s)
    };
  }
  e.generateClientServerInfiniteQuery = a;
})(C || (C = {}));
function H(e) {
  return p({
    queryKey: ["get-account-full", e],
    queryFn: async () => {
      if (!e)
        throw new Error("[SDK] Username is empty");
      const t = await i.hiveClient.database.getAccounts([e]);
      if (!t[0])
        throw new Error("[SDK] No account with given username");
      const n = JSON.parse(t[0].posting_json_metadata).profile;
      let o;
      try {
        o = await i.hiveClient.database.call(
          "get_follow_count",
          [e]
        );
      } catch {
      }
      const r = await i.hiveClient.call(
        "condenser_api",
        "get_account_reputations",
        [e, 1]
      );
      return {
        ...t[0],
        follow_stats: o,
        reputation: r[0].reputation,
        profile: {
          ...n,
          reputation: r[0].reputation
        }
      };
    },
    enabled: !!e,
    staleTime: 6e4
  });
}
function te(e, t = 5, n = []) {
  return p({
    queryKey: ["accounts", "search", e, n],
    enabled: !!e,
    queryFn: async () => (await i.hiveClient.database.call(
      "lookup_accounts",
      [e, t]
    )).filter(
      (r) => n.length > 0 ? !n.includes(r) : !0
    )
  });
}
function ne(e) {
  return p({
    queryKey: ["accounts", "check-wallet-pending", e],
    queryFn: async () => await (await fetch(
      i.privateApiHost + "/private-api/wallets-chkuser",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          username: e
        })
      }
    )).json(),
    enabled: !!e,
    refetchOnMount: !0
  });
}
function x(e, t) {
  return p({
    queryKey: ["accounts", "relations", e, t],
    enabled: !!e && !!t,
    refetchOnMount: !1,
    refetchInterval: 36e5,
    queryFn: async () => await i.hiveClient.call(
      "bridge",
      "get_relationship_between_accounts",
      [e, t]
    )
  });
}
function oe(e) {
  return p({
    queryKey: ["accounts", "subscriptions", e],
    enabled: !!e,
    queryFn: async () => await i.hiveClient.call(
      "bridge",
      "list_all_subscriptions",
      {
        account: e
      }
    ) ?? []
  });
}
function re(e) {
  return p({
    queryKey: ["accounts", "bookmarks", e],
    enabled: !!e,
    queryFn: async () => {
      if (!e)
        throw new Error("[SDK][Accounts][Bookmarks] – no active user");
      return await (await fetch(
        i.privateApiHost + "/private-api/bookmarks",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ code: y(e) })
        }
      )).json();
    }
  });
}
function ie(e) {
  return p({
    queryKey: ["accounts", "favourites", e],
    enabled: !!e,
    queryFn: async () => {
      if (!e)
        throw new Error("[SDK][Accounts][Favourites] – no active user");
      return await (await fetch(
        i.privateApiHost + "/private-api/favorites",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ code: y(e) })
        }
      )).json();
    }
  });
}
function se(e) {
  const { data: t } = q(H(e));
  return I(
    ["accounts", "update", t],
    e,
    ({ profile: n, tokens: o }) => {
      const r = {
        ...JSON.parse((t == null ? void 0 : t.posting_json_metadata) || "{}"),
        profile: { ...t == null ? void 0 : t.profile, ...n, version: 2 }
      };
      return o && o.length > 0 && (r.tokens = o), [
        [
          "account_update2",
          {
            account: e,
            posting_json_metadata: JSON.stringify(r)
          }
        ]
      ];
    }
  );
}
function ae(e, t, n, o) {
  return l({
    mutationKey: [],
    mutationFn: async (r) => {
      const c = x(
        e,
        t
      );
      await u().prefetchQuery(c);
      const a = u().getQueryData(
        c.queryKey
      );
      return await B(e, "follow", [
        "follow",
        {
          follower: e,
          following: t,
          what: [
            ...r === "toggle-ignore" && !(a != null && a.ignores) ? ["ignore"] : [],
            ...r === "toggle-follow" && !(a != null && a.follows) ? ["blog"] : []
          ]
        }
      ]), {
        ...a,
        ignores: r === "toggle-ignore" ? !(a != null && a.ignores) : a == null ? void 0 : a.ignores,
        follows: r === "toggle-follow" ? !(a != null && a.follows) : a == null ? void 0 : a.follows
      };
    },
    onError: o,
    onSuccess(r) {
      n(r), u().setQueryData(
        ["accounts", "relations", e, t],
        r
      );
    }
  });
}
function ce(e, t, n) {
  return l({
    mutationKey: ["accounts", "bookmarks", "add", e],
    mutationFn: async ({ author: o, permlink: r }) => {
      if (!e)
        throw new Error("[SDK][Account][Bookmarks] – no active user");
      return (await fetch(
        i.privateApiHost + "/private-api/bookmarks-add",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            author: o,
            permlink: r,
            code: y(e)
          })
        }
      )).json();
    },
    onSuccess: () => {
      t(), u().invalidateQueries({
        queryKey: ["accounts", "bookmarks", e]
      });
    },
    onError: n
  });
}
function ue(e, t, n) {
  return l({
    mutationKey: ["accounts", "bookmarks", "delete", e],
    mutationFn: async (o) => {
      if (!e)
        throw new Error("[SDK][Account][Bookmarks] – no active user");
      return (await fetch(
        i.privateApiHost + "/private-api/bookmarks-delete",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: o,
            code: y(e)
          })
        }
      )).json();
    },
    onSuccess: () => {
      t(), u().invalidateQueries({
        queryKey: ["accounts", "bookmarks", e]
      });
    },
    onError: n
  });
}
function pe(e, t, n) {
  return l({
    mutationKey: ["accounts", "favourites", "add", e],
    mutationFn: async (o) => {
      if (!e)
        throw new Error("[SDK][Account][Bookmarks] – no active user");
      return (await fetch(
        i.privateApiHost + "/private-api/favorites-add",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            account: o,
            code: y(e)
          })
        }
      )).json();
    },
    onSuccess: () => {
      t(), u().invalidateQueries({
        queryKey: ["accounts", "favourites", e]
      });
    },
    onError: n
  });
}
function ye(e, t, n) {
  return l({
    mutationKey: ["accounts", "favourites", "add", e],
    mutationFn: async (o) => {
      if (!e)
        throw new Error("[SDK][Account][Bookmarks] – no active user");
      return (await fetch(
        i.privateApiHost + "/private-api/favorites-delete",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            account: o,
            code: y(e)
          })
        }
      )).json();
    },
    onSuccess: () => {
      t(), u().invalidateQueries({
        queryKey: ["accounts", "favourites", e]
      });
    },
    onError: n
  });
}
function le(e) {
  return l({
    mutationKey: ["operations", "sign", e],
    mutationFn: ({
      operation: t,
      keyOrSeed: n
    }) => {
      if (!e)
        throw new Error("[Operations][Sign] – cannot sign op with anon user");
      let o;
      return n.split(" ").length === 12 ? o = h.fromLogin(e, n, "active") : P.isWif(n) ? o = h.fromString(n) : o = h.from(n), i.hiveClient.broadcast.sendOperations(
        [t],
        o
      );
    }
  });
}
function fe(e, t = "Active") {
  return l({
    mutationKey: ["operations", "sign-keychain", e],
    mutationFn: ({ operation: n }) => {
      if (!e)
        throw new Error(
          "[SDK][Keychain] – cannot sign operation with anon user"
        );
      return w(e, [n], t);
    }
  });
}
function de(e = "/") {
  return l({
    mutationKey: ["operations", "sign-hivesigner", e],
    mutationFn: async ({ operation: t }) => g.sendOperation(t, { callback: e }, () => {
    })
  });
}
function he() {
  return p({
    queryKey: ["operations", "chain-properties"],
    queryFn: async () => await i.hiveClient.database.getChainProperties()
  });
}
function ge(e, t) {
  return p({
    queryKey: ["hive-engine", "tokens-list", e, t],
    queryFn: async () => (await (await fetch(
      `${i.privateApiHost}/private-api/engine-api`,
      {
        method: "POST",
        body: JSON.stringify({
          jsonrpc: "2.0",
          method: "find",
          params: {
            contract: "market",
            table: "metrics",
            query: {
              symbol: t,
              account: e
            }
          },
          id: 1
        }),
        headers: { "Content-type": "application/json" }
      }
    )).json()).result
  });
}
function we(e = 20) {
  return F({
    queryKey: ["posts", "trending-tags"],
    queryFn: async ({ pageParam: { afterTag: t } }) => i.hiveClient.database.call("get_trending_tags", [t, e]).then(
      (n) => n.filter((o) => o.name !== "").filter((o) => !o.name.startsWith("hive-")).map((o) => o.name)
    ),
    initialPageParam: { afterTag: "" },
    getNextPageParam: (t) => ({
      afterTag: t == null ? void 0 : t[(t == null ? void 0 : t.length) - 1]
    }),
    staleTime: 1 / 0,
    refetchOnMount: !0
  });
}
function b(e) {
  return p({
    queryKey: ["posts", "fragments", e],
    queryFn: async () => (await fetch(
      i.privateApiHost + "/private-api/fragments",
      {
        method: "POST",
        body: JSON.stringify({
          code: y(e)
        }),
        headers: {
          "Content-Type": "application/json"
        }
      }
    )).json(),
    enabled: !!e
  });
}
function ve(e = "feed") {
  return p({
    queryKey: ["posts", "promoted", e],
    queryFn: async () => {
      const t = new URL(
        i.privateApiHost + "/private-api/promoted-entries"
      );
      return e === "waves" && t.searchParams.append("short_content", "1"), await (await fetch(t.toString(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      })).json();
    }
  });
}
function me(e) {
  return l({
    mutationKey: ["posts", "add-fragment", e],
    mutationFn: async ({ title: t, body: n }) => (await fetch(
      i.privateApiHost + "/private-api/fragments-add",
      {
        method: "POST",
        body: JSON.stringify({
          code: y(e),
          title: t,
          body: n
        }),
        headers: {
          "Content-Type": "application/json"
        }
      }
    )).json(),
    onSuccess(t) {
      u().setQueryData(
        b(e).queryKey,
        (n) => [t, ...n ?? []]
      );
    }
  });
}
function be(e, t) {
  return l({
    mutationKey: ["posts", "edit-fragment", e, t],
    mutationFn: async ({ title: n, body: o }) => (await fetch(
      i.privateApiHost + "/private-api/fragments-update",
      {
        method: "POST",
        body: JSON.stringify({
          code: y(e),
          id: t,
          title: n,
          body: o
        }),
        headers: {
          "Content-Type": "application/json"
        }
      }
    )).json(),
    onSuccess(n) {
      u().setQueryData(
        b(e).queryKey,
        (o) => {
          if (!o)
            return [];
          const r = o.findIndex(({ id: c }) => c === t);
          return r >= 0 && (o[r] = n), [...o];
        }
      );
    }
  });
}
function Oe(e, t) {
  return l({
    mutationKey: ["posts", "remove-fragment", e],
    mutationFn: async () => fetch(i.privateApiHost + "/private-api/fragments-delete", {
      method: "POST",
      body: JSON.stringify({
        code: y(e),
        id: t
      }),
      headers: {
        "Content-Type": "application/json"
      }
    }),
    onSuccess() {
      u().setQueryData(
        b(e).queryKey,
        (n) => [...n ?? []].filter(({ id: o }) => o !== t)
      );
    }
  });
}
function A(e, t) {
  return l({
    mutationKey: ["analytics", t],
    mutationFn: async () => {
      if (!t)
        throw new Error("[SDK][Analytics] – no activity type provided");
      await fetch(i.plausibleHost + "/api/event", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: t,
          url: window.location.href,
          domain: window.location.host,
          props: {
            username: e
          }
        })
      });
    }
  });
}
const Se = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useRecordActivity: A
}, Symbol.toStringTag, { value: "Module" }));
function G(e, t) {
  return p({
    queryKey: ["integrations", "hivesigner", "decode-memo", e],
    queryFn: async () => {
      const n = y(e);
      if (n)
        return new g.Client({
          accessToken: n
        }).decode(t);
    }
  });
}
const W = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getDecodeMemoQueryOptions: G
}, Symbol.toStringTag, { value: "Module" })), U = {
  queries: W
};
function m(e) {
  return p({
    queryKey: ["integrations", "3speak", "authenticate", e],
    enabled: !!e,
    queryFn: async () => {
      if (!e)
        throw new Error("[SDK][Integrations][3Speak] – anon user");
      const t = await fetch(
        `https://studio.3speak.tv/mobile/login?username=${e}&hivesigner=true`,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      ), n = U.queries.getDecodeMemoQueryOptions(
        e,
        (await t.json()).memo
      );
      await u().prefetchQuery(n);
      const { memoDecoded: o } = u().getQueryData(
        n.queryKey
      );
      return o.replace("#", "");
    }
  });
}
function z(e) {
  return p({
    queryKey: ["integrations", "3speak", "videos", e],
    enabled: !!e,
    queryFn: async () => {
      await u().prefetchQuery(
        m(e)
      );
      const t = u().getQueryData(
        m(e).queryKey
      );
      return await (await fetch(
        "https://studio.3speak.tv/mobile/api/my-videos",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${t}`
          }
        }
      )).json();
    }
  });
}
const $ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getAccountTokenQueryOptions: m,
  getAccountVideosQueryOptions: z
}, Symbol.toStringTag, { value: "Module" })), Ce = {
  queries: $
};
function Ke() {
  return p({
    queryKey: ["resource-credits", "stats"],
    queryFn: async () => (await i.hiveClient.call(
      "rc_api",
      "get_rc_stats",
      {}
    )).rc_stats
  });
}
function qe(e) {
  return p({
    queryKey: ["resource-credits", "account", e],
    queryFn: async () => new N(i.hiveClient).findRCAccounts([e]),
    enabled: !!e
  });
}
function ke(e, t) {
  return p({
    queryKey: ["games", "status-check", t, e],
    enabled: !!e,
    queryFn: async () => {
      if (!e)
        throw new Error("[SDK][Games] – anon user in status check");
      return await (await fetch(
        i.privateApiHost + "/private-api/get-game",
        {
          method: "POST",
          body: JSON.stringify({
            game_type: t,
            code: y(e)
          }),
          headers: {
            "Content-Type": "application/json"
          }
        }
      )).json();
    }
  });
}
function Te(e, t, n) {
  const { mutateAsync: o } = A(
    e,
    "spin-rolled"
  );
  return l({
    mutationKey: ["games", "post", t, e],
    mutationFn: async () => {
      if (!e)
        throw new Error("[SDK][Games] – anon user in game post");
      return await (await fetch(
        i.privateApiHost + "/private-api/post-game",
        {
          method: "POST",
          body: JSON.stringify({
            game_type: t,
            code: y(e),
            key: n
          }),
          headers: {
            "Content-Type": "application/json"
          }
        }
      )).json();
    },
    onSuccess() {
      o();
    }
  });
}
function Ae(e, t, n = 100, o = void 0, r = !0) {
  return p({
    queryKey: ["communities", "list", e, t, n],
    enabled: r,
    queryFn: async () => {
      const c = await i.hiveClient.call(
        "bridge",
        "list_communities",
        {
          last: "",
          limit: n,
          sort: e === "hot" ? "rank" : e,
          query: t || null,
          observer: o
        }
      );
      return c ? e === "hot" ? c.sort(() => Math.random() - 0.5) : c : [];
    }
  });
}
function Qe(e, t) {
  return p({
    queryKey: ["community", "context", e, t],
    enabled: !!e && !!t,
    queryFn: async () => {
      const n = await i.hiveClient.call(
        "bridge",
        "get_community_context",
        {
          account: e,
          name: t
        }
      );
      return {
        role: (n == null ? void 0 : n.role) ?? "guest",
        subscribed: (n == null ? void 0 : n.subscribed) ?? !1
      };
    }
  });
}
var f = /* @__PURE__ */ ((e) => (e.OWNER = "owner", e.ADMIN = "admin", e.MOD = "mod", e.MEMBER = "member", e.GUEST = "guest", e.MUTED = "muted", e))(f || {});
const _e = {
  owner: [
    "admin",
    "mod",
    "member",
    "guest",
    "muted"
    /* MUTED */
  ],
  admin: [
    "mod",
    "member",
    "guest",
    "muted"
    /* MUTED */
  ],
  mod: [
    "member",
    "guest",
    "muted"
    /* MUTED */
  ]
};
function je(e, t) {
  return e.startsWith("hive-3") || t === 3 ? "Council" : e.startsWith("hive-2") || t === 2 ? "Journal" : "Topic";
}
function Fe({
  communityType: e,
  userRole: t,
  subscribed: n
}) {
  const o = t === f.MUTED ? !1 : e === "Topic" ? !0 : [f.OWNER, f.ADMIN, f.MOD, f.MEMBER].includes(
    t
  ), r = (() => {
    if (t === f.MUTED) return !1;
    switch (e) {
      case "Topic":
        return !0;
      case "Journal":
        return t !== f.GUEST || n;
      case "Council":
        return o;
    }
  })(), c = [f.OWNER, f.ADMIN, f.MOD].includes(t);
  return {
    canPost: o,
    canComment: r,
    isModerator: c
  };
}
export {
  i as CONFIG,
  S as ConfigManager,
  Se as EcencyAnalytics,
  C as EcencyQueriesManager,
  U as HiveSignerIntegration,
  R as Keychain,
  f as ROLES,
  Ce as ThreeSpeakIntegration,
  B as broadcastJson,
  ne as checkUsernameWalletsPendingQueryOptions,
  y as getAccessToken,
  H as getAccountFullQueryOptions,
  qe as getAccountRcQueryOptions,
  oe as getAccountSubscriptionsQueryOptions,
  re as getActiveAccountBookmarksQueryOptions,
  ie as getActiveAccountFavouritesQueryOptions,
  he as getChainPropertiesQueryOptions,
  Ae as getCommunitiesQueryOptions,
  Qe as getCommunityContextQueryOptions,
  Fe as getCommunityPermissions,
  je as getCommunityType,
  b as getFragmentsQueryOptions,
  ke as getGameStatusCheckQueryOptions,
  ge as getHiveEngineTokensListQueryOptions,
  T as getLoginType,
  k as getPostingKey,
  ve as getPromotedPostsQuery,
  u as getQueryClient,
  Ke as getRcStatsQueryOptions,
  L as getRefreshToken,
  x as getRelationshipBetweenAccountsQueryOptions,
  te as getSearchAccountsByUsernameQueryOptions,
  we as getTrendingTagsQueryOptions,
  d as getUser,
  ee as makeQueryClient,
  _e as roleMap,
  pe as useAccountFavouriteAdd,
  ye as useAccountFavouriteDelete,
  ae as useAccountRelationsUpdate,
  se as useAccountUpdate,
  me as useAddFragment,
  ce as useBookmarkAdd,
  ue as useBookmarkDelete,
  I as useBroadcastMutation,
  be as useEditFragment,
  Te as useGameClaim,
  Oe as useRemoveFragment,
  de as useSignOperationByHivesigner,
  le as useSignOperationByKey,
  fe as useSignOperationByKeychain
};
